// apps/web/src/admin/PurgeConfirmModal.tsx
import { useState } from 'react';
import { ModalOverlay } from '../components/ModalOverlay.js';

interface Props {
  email: string;
  isGuide: boolean;
  busy: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}

export function PurgeConfirmModal({ email, isGuide, busy, error, onCancel, onConfirm }: Props) {
  const [typed, setTyped] = useState('');
  const [reason, setReason] = useState('');
  const matches = typed.trim().toLowerCase() === email.trim().toLowerCase();

  return (
    <ModalOverlay className="z-50 bg-black/50" role="dialog" aria-modal="true">
      <div className="w-full max-w-[460px] rounded-lg border border-ink-200 dark:border-white/10 bg-canvas-light dark:bg-canvas-dark p-6">
        <h2 className="text-lg font-semibold text-red-600">Purge account — this cannot be undone</h2>
        <p className="mt-3 text-sm text-ink-700 dark:text-ink-200">
          This permanently deletes <strong>all data</strong> for <strong>{email}</strong> on ASL Go: their profile,
          call history, and payments &amp; credit balance{isGuide ? ', plus their intro video and résumé' : ''}.
        </p>
        <p className="mt-2 text-sm text-ink-500">
          This does <strong>not</strong> remove anything from Stripe.
        </p>

        <label className="mt-4 block text-sm">
          Reason (optional)
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2}
            className="mt-1 w-full rounded border border-ink-200 dark:border-white/10 bg-transparent p-2 text-sm" />
        </label>

        <label className="mt-3 block text-sm">
          Type <strong>{email}</strong> to confirm
          <input value={typed} onChange={(e) => setTyped(e.target.value)} autoComplete="off"
            className="mt-1 w-full rounded border border-ink-200 dark:border-white/10 bg-transparent p-2 text-sm" />
        </label>

        {error ? <p className="mt-2 text-sm text-red-600">{error}</p> : null}

        <div className="mt-5 flex justify-end gap-2">
          <button className="btn" onClick={onCancel} disabled={busy}>Cancel</button>
          <button className="btn bg-red-600 text-white disabled:opacity-40" disabled={!matches || busy}
            onClick={() => onConfirm(reason.trim())}>
            {busy ? 'Purging…' : 'Purge account'}
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
